import React from 'react';
import { Box, Alert } from '@mui/material';
import SubscriptionCancellationBanner from '../SubscriptionCancellationBanner';

interface OrganizationInfo {
  plan: string;
  monthlySimQuota?: number;
  simUsed?: number;
  status?: string;
  nextBillingAt?: string;
}

interface OrganizationQuotaBannerProps {
  orgInfo: OrganizationInfo | null;
  isAdmin?: boolean;
  resourceType?: 'simulations' | 'ideas';
}

const OrganizationQuotaBanner: React.FC<OrganizationQuotaBannerProps> = ({ 
  orgInfo, 
  isAdmin = false,
  resourceType = 'simulations'
}) => {
  if (!orgInfo) return null;

  const remaining = orgInfo.monthlySimQuota ? orgInfo.monthlySimQuota - (orgInfo.simUsed || 0) : 0;
  const hasReachedLimit = orgInfo.plan !== 'INTERNAL' && remaining <= 0;

  return (
    <Box sx={{ mt: 2 }}>
      {hasReachedLimit ? (
        <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
          Your organization has reached the {resourceType} limit. Please contact your administrator to upgrade your plan.
        </Alert>
      ) : orgInfo.plan === 'INTERNAL' ? (
        <Alert severity="info" sx={{ mt: 2 }}>
          Your organization has unlimited {resourceType}.
        </Alert>
      ) : (
        <Alert severity="info" sx={{ mt: 2 }}>
          Your organization has {remaining} {resourceType} remaining.
        </Alert>
      )}

      {/* Show cancellation warning if applicable */}
      {orgInfo.status === 'ACTIVE_UNTIL' && orgInfo.nextBillingAt && (
        <Box sx={{ mt: 2 }}>
          <SubscriptionCancellationBanner
            expiryDate={orgInfo.nextBillingAt}
            isAdmin={isAdmin}
          />
        </Box>
      )}
    </Box>
  );
};

export default OrganizationQuotaBanner; 